import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import CommercialSessionTable from './CommercialSessionTable';
import PersonalSessionTable from './PersonalSessionTable';

/**
 * Charging Sessions Container Component
 * @returns {any} The result
 */
function EMSPChargingSessions() {
  const { i18n } = useTranslation();
  const [searchParameters] = useSearchParams();
  const chargerType = searchParameters.get('chargerType');
  const [currentPage, setCurrentPage] = useState<string>(chargerType || 'commercial');
  useEffect(() => {
    if (chargerType) {
      setCurrentPage(chargerType);
    }
  }, [chargerType]);
  return (
    <div className="body-container" dir={i18n.dir()}>
      <div className="table-content">
        {currentPage === 'commercial' && (
          <CommercialSessionTable setCurrentPage={setCurrentPage} currentPage={currentPage} />
        )}
        {currentPage === 'personal' && (
          <PersonalSessionTable setCurrentPage={setCurrentPage} currentPage={currentPage} />
        )}
      </div>
    </div>
  );
}

export default EMSPChargingSessions;
